/** Translucent card floating above the composer: the "remember this?" prompt, its confirmation, and the notification offer. */
export const FLOATING_CARD_CLASS = 'rounded-lg bg-background/95 shadow-sm px-4 py-3';

/**
 * Set directly rather than via Tailwind's `backdrop-blur-*`, which emits only the unprefixed property
 * through a chain of CSS variables; the prefixed one covers WebKit builds that still need it.
 */
export const FLOATING_CARD_STYLE = { backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' };
